<script>
  import Footer from "../dumb-components/Footer.svelte";
  import ButtonContainer from '../dumb-components/ButtonContainer.svelte';
  import Button from '../dumb-components/Button.svelte';
  import Row from './Row.svelte';
  import Imprint from './Imprint.svelte';

  const { config, mainData, onSelectAll, onConfirmSelection } = $$props;
</script>

<Footer {config}>
  <Row class="justify-center row-reverse">
    <ButtonContainer {config}>
      <Button buttonClass="privacy-consent--button-secondary" id="confirmSelection" onClick={onConfirmSelection}>
        {config.confirmSelection}
      </Button>
    </ButtonContainer>

    <ButtonContainer {config}>
      <Button buttonClass="privacy-consent--button-primary" id="selectAll" onClick={onSelectAll}>
        {config.selectAllDefault}
      </Button>
    </ButtonContainer>

    <Imprint {config} />
  </Row>
</Footer>